import { SUBSCRIPTION_SECTION_IDS } from 'nove8/modules/subscriptions/constants'
import React, { ButtonHTMLAttributes, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { LOCALES } from 'root-constants'
import Arrow from '../assets/images/sprite/right-white-arrow.svg'
import { StyledFlowButton as S } from './FlowButton.styles'

export interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  buttonRef?: React.Ref<HTMLButtonElement>
  onClick?: () => void
  isButtonDisabled?: boolean
  text?: string
  style?: any
  id?: string
  hasArrow?: boolean
  leadingIcon?: React.ReactNode
  isLongLocale?: boolean
  testId?: string
}

export const FlowButton: React.FC<IProps> = ({
  onClick,
  isButtonDisabled = false,
  text,
  style,
  id,
  buttonRef,
  hasArrow = true,
  leadingIcon,
  isLongLocale = false,
  testId,
  ...props
}) => {
  const { t, i18n } = useTranslation()

  const isFrLocale = useMemo(() => i18n.language === LOCALES.FR, [
    i18n.language,
  ])

  return (
    <S.ButtonFullWidth
      style={{ ...style }}
      disabled={isButtonDisabled}
      onClick={onClick}
      id={id || SUBSCRIPTION_SECTION_IDS.startMyPlanButton}
      isFrLocale={isFrLocale}
      buttonRef={buttonRef}
      data-testid={testId || 'quiz-continue-button'}
      {...props}
    >
      {leadingIcon && <S.IconLeft>{leadingIcon}</S.IconLeft>}
      <S.ButtonText isLeadingIcon={!!leadingIcon} isLongLocale={isLongLocale}>
        {text || t`actions.continue`}
      </S.ButtonText>
      {hasArrow && (
        <S.IconRight>
          <Arrow height={24} width={24} />
        </S.IconRight>
      )}
    </S.ButtonFullWidth>
  )
}
